import { Select } from 'antd';

import { Flex, VFlex } from '@/components/base';
import ExpandSearchInput from '@/components/Inputs/ExpandSearchInput';
import { useSearch } from '@/components/Inputs/useSearch';
import AMP_KEYS from '@/configs/amp-track-keys';
import { WORKSPACE_IDS } from '@/configs/workspace-ids';
import useWorkspaceId from '@/hooks/domain/useWorkspaceId';
import keymap from '@/utils/keymap';
import { track } from '@/utils/track/track';

import {
  InsightExplorerByTypeMap,
  InsightExplorerFieldType,
  InsightExplorerFieldTypeMap,
} from '../../types/constants';
import HierarchyNavigator from './HierarchyNavigator/HierarchyNavigator';
import { SidebarContainer, TreeContainer } from './styles';
import type { InsightExplorerSidebarProps } from './types';

const InsightExplorerSidebar = (props: InsightExplorerSidebarProps) => {
  const workspaceId = useWorkspaceId();
  const { initSearchValue, onKeyEnterSearch, searchValue } = useSearch();
  const fieldTypeOptions =
    workspaceId === WORKSPACE_IDS.HITE_JINRO
      ? [
          {
            value: InsightExplorerFieldType.TAG,
            label: InsightExplorerFieldTypeMap.get(InsightExplorerFieldType.TAG),
          },
          {
            value: InsightExplorerFieldType.TAXONOMY,
            label: InsightExplorerFieldTypeMap.get(
              InsightExplorerFieldType.TAXONOMY,
            ),
          },
        ]
      : InsightExplorerFieldTypeMap.toArray();

  return (
    <SidebarContainer>
      <VFlex padding="20px 28px" g={12}>
        <Flex j="space-between" a="center">
          <Select
            value={props.selectedField}
            onChange={(value) => {
              track(AMP_KEYS.INSIGHT_EXPLORER_FIELD_SELECT, {
                field: InsightExplorerFieldTypeMap.get(value),
              });
              props.onFieldChange(value);
            }}
            size="middle"
            options={fieldTypeOptions}
            style={{ width: '100%' }}
          />
        </Flex>
        <ExpandSearchInput
          placeholder="Search"
          onKeyDown={(e) => {
            if (keymap.isEnter(e)) {
              track(AMP_KEYS.INSIGHT_EXPLORER_NODE_SEARCH_ENTER, {
                keyword: e.currentTarget.value,
              });
              onKeyEnterSearch(e);
            }
          }}
          onClearInput={(el) => {
            if (el) {
              initSearchValue();
            }
          }}
          sizeType="m"
        />
      </VFlex>

      <TreeContainer>
        <VFlex>
          <HierarchyNavigator
            data={props.treeData.data}
            searchValue={searchValue}
            onNodeSelect={(node) => {
              track(AMP_KEYS.INSIGHT_EXPLORER_NODE_SELECT, {
                node_type: InsightExplorerByTypeMap.get(node.node_type),
                node_name: node.name,
              });
              props.onNodeSelect(node);
            }}
            selectedNodeId={props.selectedNodeId}
          />
        </VFlex>
      </TreeContainer>
    </SidebarContainer>
  );
};

export default InsightExplorerSidebar;
